function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgBg = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 195,
  height: 78,
  fill: "none",
  viewBox: "0 0 195 78"
}, props), /*#__PURE__*/React.createElement("path", {
  fill: "#1380FF",
  d: "M26.285 0C30.33 3.344 55.267 31.433 93.01 34.108 132.1 36.783 162.43 6.688 168.495 0l25.612 22.07c-4.044 4.681-21.568 36.114-64.703 50.159-40.438 12.707-75.485-.669-97.727-16.72C12.806 42.133 0 22.74 0 22.07z",
  opacity: 0.1,
  style: {
    mixBlendMode: "multiply"
  }
}));
export { SvgBg as ReactComponent };